import apiClient from './client';
import { AuthResponse, User } from '../types';

export interface UpdateProfileData {
  username?: string;
  profile?: {
    companyName?: string;
    businessType?: string;
    country?: string;
    city?: string;
    venueName?: string;
    venueAddress?: string;
  };
}

export interface ChangePasswordData {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface DeleteAccountResponse {
  deletedAt: string;
}

export interface ForgotPasswordData {
  email: string;
  lang?: string;
}

export interface ResetPasswordData {
  token: string;
  newPassword: string;
}

export interface RegisterData {
  email: string;
  password: string;
  correspondenceLanguage?: string;
  referralCode?: string;
  visitorId?: string;
}

export const authApi = {
  register: async (data: RegisterData) => {
    const response = await apiClient.post<AuthResponse>('/auth/register', data);
    return response.data;
  },

  login: async (data: { email: string; password: string }) => {
    const response = await apiClient.post<AuthResponse>('/auth/login', data);
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await apiClient.get<User>('/auth/me');
    return response.data;
  },

  updateProfile: async (data: UpdateProfileData) => {
    const response = await apiClient.patch<User>('/auth/me', data);
    return response.data;
  },

  changePassword: async (data: ChangePasswordData) => {
    const response = await apiClient.post<{ success: boolean }>('/auth/change-password', data);
    return response.data;
  },

  deleteAccount: async (password: string) => {
    const response = await apiClient.post<DeleteAccountResponse>('/auth/delete-account', { password });
    return response.data;
  },

  cancelDeletion: async () => {
    const response = await apiClient.post<{ success: boolean }>('/auth/cancel-deletion');
    return response.data;
  },

  verifyEmail: async (token: string) => {
    const response = await apiClient.get<{ message: string }>(`/auth/verify-email?token=${token}`);
    return response.data;
  },

  resendVerificationEmail: async (lang?: string) => {
    const response = await apiClient.post<{ message: string }>('/auth/resend-verification', { lang });
    return response.data;
  },

  forgotPassword: async (data: ForgotPasswordData) => {
    const response = await apiClient.post<{ message: string }>('/auth/forgot-password', data);
    return response.data;
  },

  resetPassword: async (data: ResetPasswordData) => {
    const response = await apiClient.post<{ message: string }>('/auth/reset-password', data);
    return response.data;
  },

  updateCorrespondenceLanguage: async (language: string) => {
    const response = await apiClient.patch<User>('/auth/correspondence-language', { language });
    return response.data;
  },
};
